import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const PricingApi = createApi({
  reducerPath: "PricingApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["PRICINGAPI"],
  endpoints: (build) => ({
    getPricing: build.query({
      query: ({
        page = 1,
        searchTerm = "",
        vehicleType = "",
        active = "",
      }) => ({
        url: `/pricing?page=${page}&search=${searchTerm}&vehicleType=${vehicleType}&active=${active}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["PRICINGAPI"],
    }),

    getPricingById: build.query({
      query: ({ id }) => ({
        url: `/pricing/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["PRICINGAPI"],
    }),

    getPricingForLocation: build.query({
      query: ({ longitude, latitude, vehicleType = "" }) => ({
        url: `/pricing/location?longitude=${longitude}&latitude=${latitude}&vehicleType=${vehicleType}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["PRICINGAPI"],
    }),

    addPricing: build.mutation({
      query: ({ data }) => ({
        url: `/pricing`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PRICINGAPI"],
    }),

    bulkCreatePricing: build.mutation({
      query: ({ data }) => ({
        url: `/pricing/bulk`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PRICINGAPI"],
    }),

    editPricing: build.mutation({
      query: ({ id, data }) => ({
        url: `/pricing/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PRICINGAPI"],
    }),

    deletePricing: build.mutation({
      query: ({ id }) => ({
        url: `/pricing/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PRICINGAPI"],
    }),

    getLongDrivePricing: build.query({
      query: ({
        page = 1,
        searchTerm = "",
        vehicleType = "",
        active = "",
      }) => ({
        url: `/longdrive-pricing?page=${page}&search=${searchTerm}&vehicleType=${vehicleType}&active=${active}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["PRICINGAPI"],
    }),

    getLongDrivePricingById: build.query({
      query: ({ id }) => ({
        url: `/longdrive-pricing/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["PRICINGAPI"],
    }),

    addLongDrivePricing: build.mutation({
      query: ({ data }) => ({
        url: `/longdrive-pricing`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PRICINGAPI"],
    }),

    editLongDrivePricing: build.mutation({
      query: ({ id, data }) => ({
        url: `/longdrive-pricing/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PRICINGAPI"],
    }),

    deleteLongDrivePricing: build.mutation({
      query: ({ id }) => ({
        url: `/longdrive-pricing/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PRICINGAPI"],
    }),
  }),
});

export const {
  useGetPricingQuery,
  useGetPricingByIdQuery,
  useGetPricingForLocationQuery,
  useAddPricingMutation,
  useBulkCreatePricingMutation,
  useEditPricingMutation,
  useDeletePricingMutation,
  useGetLongDrivePricingQuery,
  useGetLongDrivePricingByIdQuery,
  useAddLongDrivePricingMutation,
  useEditLongDrivePricingMutation,
  useDeleteLongDrivePricingMutation,
} = PricingApi;

